<template>
  <div class="input input-with-addon">
    <input type="text" v-model="password" readonly>
    <div class="buttons">
      <a v-clipboard:copy="password" v-clipboard:success="onCopy" v-clipboard:error="onError">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path fill="#200064" d="M366.905,108.016h-141.91c-11.048,0-20.003,8.955-20.003,20.003s8.955,20.003,20.003,20.003h141.91
	c11.048,0,20.003-8.955,20.003-20.003S377.952,108.016,366.905,108.016z" />
          <path fill="#200064" d="M366.905,188.027h-141.91c-11.048,0-20.003,8.955-20.003,20.003s8.955,20.003,20.003,20.003h141.91
	c11.047,0,20.003-8.955,20.003-20.003S377.953,188.027,366.905,188.027z" />
          <path fill="#200064" d="M286.004,268.039h-61.009c-11.048,0-20.003,8.955-20.003,20.003c0,11.048,8.955,20.003,20.003,20.003h61.009
	c11.048,0,20.003-8.955,20.003-20.003C306.007,276.994,297.052,268.039,286.004,268.039z" />
          <path fill="#200064" d="M448.028,272.039c11.048,0,20.003-8.955,20.003-20.003V80.012C468.031,35.893,432.137,0,388.019,0H203.992
	c-44.094,0-79.971,35.853-80.012,79.938c-44.118,0-80.012,35.893-80.012,80.012v272.039c0,44.118,35.893,80.012,80.012,80.012
	h194.028c44.118,0,80.012-35.893,80.012-80.012v-0.608c39.414-4.938,70.01-38.662,70.01-79.389
	c0-11.048-8.955-20.003-20.003-20.003c-11.048,0-20.003,8.955-20.003,20.003c0,22.054-17.942,40.001-39.996,40.006l-184.027,0.045
	h-0.009c-10.685,0-20.73-4.16-28.285-11.715c-7.558-7.556-11.721-17.604-11.721-28.291V80.012
	c0-22.059,17.947-40.006,40.006-40.006H388.02c22.059,0,40.006,17.947,40.006,40.006v172.025
	C428.025,263.084,436.98,272.039,448.028,272.039z M203.992,432.047h0.02l154.002-0.038
	c-0.012,22.049-17.954,39.984-40.006,39.984H123.981c-22.059,0-40.006-17.947-40.006-40.006V159.948
	c0-22.059,17.947-40.006,40.006-40.006v232.094c0,21.375,8.325,41.471,23.441,56.583
	C162.535,423.729,182.622,432.047,203.992,432.047z" />
        </svg>
      </a>
      <a @click="refresh">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999">
          <path fill="#200064" d="M367.585,458.394c-5.307-9.686-17.462-13.236-27.149-7.929c-25.712,14.088-54.909,21.534-84.436,21.534
			c-97.047,0-176-78.953-176-176.004c0-11.046-8.954-19.998-20-19.998s-20,8.956-20,20.002c0,57.696,22.468,111.938,63.265,152.735
			S198.304,511.999,256,511.999c36.226,0,72.07-9.148,103.656-26.455C369.343,480.236,372.893,468.081,367.585,458.394z" />
          <path fill="#200064" d="M408.735,143.264C367.938,102.467,313.696,79.999,256,79.999h-73.261l45.473-45.928c7.771-7.85,7.708-20.513-0.141-28.284
			c-7.85-7.771-20.512-7.708-28.284,0.141l-51.4,51.915c-22.961,23.191-23.094,61.058-0.296,84.411l50.487,51.717
			c3.919,4.015,9.113,6.029,14.313,6.029c5.037,0,10.08-1.892,13.97-5.688c7.904-7.716,8.056-20.378,0.34-28.282l-44.934-46.031H256
			c97.047,0,176,78.953,176,176c0,30.425-7.881,60.403-22.792,86.691c-5.45,9.608-2.079,21.814,7.529,27.264
			c3.116,1.768,6.505,2.607,9.849,2.607c6.966,0,13.733-3.645,17.415-10.136C462.318,370.13,472,333.329,472,295.999
			C472,238.303,449.532,184.061,408.735,143.264z" />
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
import { toast } from '../toast';
import DummyPassword from '../dummy-password';
const dummy = new DummyPassword();

export default {
  name: 'PasswordGenerator',
  props: ['options'],
  data() {
    return {
      password: '',
    };
  },
  methods: {
    generate() {
      const characters = [];
      for (let option in this.options) {
        if (this.options[option] === true) characters.push(dummy[option.toUpperCase()]);
      }
      this.password = dummy.create(this.options.length, characters.join(''));
    },
    refresh() {
      this.generate();
    },
    onCopy() {
      toast({ message: 'Copied!' });
    },
    onError() {
      toast({ message: `I didn't copy that!` });
    },
  },
  watch: {
    options: {
      handler: function() {
        this.generate();
      },
      deep: true,
    },
  },
  mounted() {
    this.generate();
  },
};
</script>

<style scoped>
a svg {
  width: 30px;
  cursor: pointer;
}

.input {
  text-align: left;
}

.input-with-addon {
  display: flex;
  background: #ffffff;
  padding: 15px 20px;
  border-radius: 10px;
}

.input-with-addon input {
  width: 100%;
  flex: 1;
  font-size: 2rem;
  color: #200064;
  border: 0;
  outline: none;
}

.buttons {
  position: relative;
  padding: 5px 0;
}

.input-with-addon .buttons a {
  user-select: none;
  padding: 0 5px;
  background: transparent;
}
</style>
